import { html } from 'lit';
import { MonitorCog } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-monitor-cog')
export class PdsIconMonitorCog extends PdsIcon {
  @state()
  icon = MonitorCog;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
